import axios from '@/api/axios';
import { gql } from '@/api/utils';

export default {
  async getUser() {
    try {
      const query = gql`
        query user {
          user {
            __typename
            id
            email
            ... on Administrator {
              status
              roles
            }
            ... on PetOwner {
              firstName
              lastName
              addressDisplay
              city {
                showCollarsLeashesProducts
                showPetEssentialsProducts
                showPetTrackerInStoreForPetOwner
                logo {
                  original
                }
                branding {
                  phone
                  logoImage {
                    original
                  }
                  customerSupportPhone
                }
              }
            }
          }
        }
      `;

      const { user: results } = await axios.post(`/`, { query });
      return results;
    } catch (error) {
      return Promise.reject({
        message: error.message,
      });
    }
  },
  async fetchCity(cityId) {
    try {
      const marketingCollectionContentQuery = `
        marketingContentCollectionItems {
          marketingContent {
            type
            ... on MarketingContentHTML {
              html
            }
            ... on MarketingContentImage {
              image {
                original
              }
              resolution
              alternativeText
            }
            ... on MarketingContentCarousel {
              linkName
              productGroup {
                id
                name
                productType
                productStyles(cityId: $cityId) {
                  id
                  code
                  name
                  price
                  description
                  discountedPrice
                  description
                  image {
                    original
                    thumbnail
                  }
                  images {
                    id
                    original
                  }
                  priceRange {
                    min
                    max
                  }
                  productType
                  hasMultipleSKUs
                  productGroups {
                    id
                    status
                    doNotDisplayInStore
                  }
                  products {
                    id
                    type
                    name
                    status
                    __typename
                    ... on CollarProduct {
                      size
                      color
                      price
                      discountedPrice
                      status
                      image {
                        original
                      }
                      backImage {
                        original
                      }
                      sizeTitle
                      sizeLength
                      sizeWidth
                      sizeDescription
                      sizeImage {
                        original
                      }
                      personalization {
                        price
                      }
                      price
                      discountedPrice
                    }
                  }
                }
              }
            }
          }
          position
        }
      `;
      const query = gql`
        query Query($cityId: ID!) {
          city(id: $cityId) {
            id
            logo {
              original
            }
            letterLogo {
              original
            }
            branding {
              logoImage {
                original
              }
              walletCardInterstitialHeaderHtml
              walletCardInterstitialDescriptionHtml
              walletCardInterstitialCheckboxDescriptionHtml
              walletCardReviewAdditionalCardsHtml
            }
            name
            noLicensing
            safeAndHappyFund
            showStoreHomePage
            showCollarsLeashesProducts
            showPetTrackerInStoreForPetOwner
            showPetEssentialsProducts
            displayHomeSafePage
            displayLicensingPage
            displaySafeAndHappyFundPage
            displayAboutPage
            htmlSafeAndHappyFundLinkTitle
            htmlLicensingLinkTitle
            htmlHomesafeLinkTitle
            multitagDiscountText
            marketingCopy
            marketingCopyImage {
              original
            }
            marketingLicensingCopy
            marketingLicensingCopyImage {
              original
            }
            marketingAdminCopy
            marketingAdminCopyImage {
              original
            }
            customerService {
              phoneNumber
            }
            petOwnerStoreMessage
            displayPetOwnerStoreMessageForCollars
            displayPetOwnerStoreMessageForPetEssentials
            ${[
              'tagsLandingPagePrimaryMarketingCollection',
              'tagsLandingPageSecondaryMarketingCollection',
              'homeLandingPageHeroMarketingCollection',
              'homeLandingPageTagsMarketingCollection',
              'homeLandingPageWalletCardsMarketingCollection',
              'homeLandingPageCollarsMarketingCollection',
              'homeLandingPagePetEssentialsMarketingCollection',
              'walletCardLandingPageMarketingCollection',
              'collarsAndLeashesLandingPageMarketingCollection',
            ]
              .map(
                (collection) => `${collection} {
                  ${marketingCollectionContentQuery}
                }`
              )
              .join('\n')}
            showWalletCardProducts
            tagConfigEnableKeychainAddon
            isTagPersonalizationDisabledByDefault
            useReplacementTagInLicensingFlow
            replaceTagStoreCTAOption
            customDescriptionSkipTagInLicensingFlow
            freePetTagProductGroup {
              id
              name
              productType
              image {
                  original
                  thumbnail
              }
              price
              productStyles(cityId: $cityId) {
                  id
                  code
                  name
                  price
                  discountedPrice
              }
            }
          }
        }
      `;

      const variables = { cityId };
      const { city: results } = await axios.post(`/`, { query, variables });
      return results;
    } catch (error) {
      return Promise.reject({
        message: error.message,
      });
    }
  },
};
